<template>
  <div class="container-fluid" style="margin-top: 20px">
    <div class="row-fluid">
      <!--最新活动-->
      <div class="span12 text-left">
        <div class="cent" v-if="list == ''">暂无审核</div>
        <div class="row-fluid" v-else>
          <div class="span12">
            <div
              class="jumbotron"
              v-for="(item, index) in list"
              :key="index"
              style="padding: 10px 15px"
            >
              <!-- @click="route(item.id)" -->
              <div class="row b_x tt_x_10" style="padding: 2px 0px 14px">
                <div class="col-9" style="padding-left: 10px">
                  <span
                    class="label"
                    style="
                      color: #3480fa;
                      background-color: #ffd986;
                      border-radius: 50px/50px;
                    "
                    >{{ item.community ? item.community : "暂无社区" }}</span
                  >&nbsp;
                  <!-- | <span
                    style="position: relative;top: 1px;">{{item.support_start_time?item.support_start_time:""}}</span> -->
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.support_community_pass == 0"
                >
                  等待审核
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.support_community_pass == 1"
                >
                  已通过
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.support_community_pass == 2"
                >
                  已驳回
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.support_community_pass == 3"
                >
                  再次申请
                </div>
              </div>
              <div class="row t_10">
                <div
                  class="col-12"
                  style="
                    line-height: 25px;
                    padding-right: 15px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ item.assistance_text }}
                </div>
                <div class="row col-12" style="margin-top: 5px">
                  <div class="col-3" style="padding-right: 0">
                    <span class="glyphicon glyphicon-user"></span>
                    {{ item.username }}
                  </div>
                  <div class="col-9">{{ item.telephone }}</div>
                </div>
                <div class="col-12" style="height: 3px"></div>
                <div class="col-12 t_5 t_x_10">
                  <span class="glyphicon glyphicon-flag"></span>
                  {{ item.assistance_address.substring(6) }}
                </div>
                <div class="col-12" style="height: 3px"></div>
              </div>
              <div class="row b_t tt_10 t_x_10" style="margin-bottom: 0px">
                <div class="col-6">
                  <h5 v-if="item.nick_name == 1">生活服务</h5>
                  <h5 v-if="item.nick_name == 2">文化服务</h5>
                  <h5 v-if="item.nick_name == 3">帮扶服务</h5>
                </div>
                <div class="col-12 text-right" v-if="item.state != 1">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.stop="pass_db(item.id, 2)"
                  >
                    &nbsp;&nbsp;驳回&nbsp;&nbsp;
                  </button>

                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.stop="pass_db(item.id, 1)"
                  >
                    &nbsp;&nbsp;通过&nbsp;&nbsp;
                  </button>

                  <!-- <button type="button" class="btn btn-primary" v-if="item.assistance_state == 0">等待接单</button>
                  <button type="button" class="btn btn-primary" v-if="item.assistance_state == 1">已接单</button>
                  <button type="button" class="btn btn-primary" v-if="item.assistance_state == 2">完成结单</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="jumbotron_c t_20">
          <div class="row">
            <div class="col-3" style="padding-right:0px;">
              <div style="padding:10px 0px 10px 10px;">
                <img style="width: 100%; height: 70px;" src="https://img.hsnms.com/20210807/1628335448.jpg" />
              </div>
            </div>
            <div class="col-9">
              <h5 class="h5_t_5"><span class="label label-primary label_50">主要标签</span> 是服务队伍的聚集地</h5>
              <footer class="blockquote-footer">From WWF's website</footer>
              <h5 class="text-right" style="margin-bottom:0px; padding-top: 3px;"><span
                  class="label label-primary-j">详细信息</span></h5>
            </div>
          </div>
        </div> -->
        <div v-if="list != ''">
          <button
            v-if="moreShowBoolen"
            @click="moreShow1"
            class="btn_page btn1"
            style="
              display: block;
              margin: 25px auto 0;
              outline: none;
              color: #666;
              background-color: #eee;
              border-radius: 25px;
              height: 30px;
              width: 60%;
            "
          >
            更多选项
          </button>
          <div v-else style="text-align: center; margin-top: 15px">
            已无更多
          </div>
        </div>
        <div id="d_p"></div>
      </div>
    </div>
    <pop :show5="showji" message="审核完成" @editshow="editshow" />
  </div>
</template>

<script>
import pop from "./popup.vue";
//import user_model from '../tool/user_model'
export default {
  name: "Loading",
  data() {
    return {
      showji: false,
      list: [],
      community: "",
      keysid: "",
      nowPage: 1,
      moreShowBoolen: false,
      nowPage_t: 1,
    };
  },
  components: {
    pop,
  },
  props: {},
  created() {},
  mounted() {
    this.moreShow1();
    // app/mutual/assistance/id的值?appid=202108&type_id=3001
    // this.$api.getAPI("mutual/assistance/?appid=202108&type_id=3001", {
    //   recommend: this.$api.getUserInfo().community,
    // }).then(res => {
    //   this.list = res.data.data.data[0].models
    //   // console.log(this.list);
    //   this.$api.getAPI("build/app/202108?state=1").then(res => {
    //     // console.log(res.data.data.frame_users);
    //     for (let i = 0; i < this.list.length; i++) {
    //       for (let j = 0; j < res.data.data.frame_users.length; j++) {
    //         if (this.list[i].community == res.data.data.frame_users[j].id) {
    //           this.list[i].community = res.data.data.frame_users[j].value
    //         }
    //       }
    //     }
    //   })
    // })
  },
  methods: {
    moreShow1() {
      // 点击查询更多
      //if(pageid)
      this.$api
        .getAPI("mutual/assistance/?appid=202108&type_id=3001&size=10", {
          recommend: this.$api.getUserInfo().community,
          page: this.nowPage,
        })
        .then((res) => {
          for (let i = 0; i < res.data.data.data[0].models.length; i++) {
            this.list.push(res.data.data.data[0].models[i]);
          }
          this.$api.getAPI("build/app/202108?state=1").then((res) => {
            for (let i = 0; i < this.list.length; i++) {
              for (let j = 0; j < res.data.data.frame_users.length; j++) {
                if (this.list[i].community == res.data.data.frame_users[j].id) {
                  this.list[i].community = res.data.data.frame_users[j].value;
                }
              }
            }
          });
          var db = res.data.data.data[0];
          this.nowPage_t = db.page.count;
          this.moreShowBoolen = true;
          if (this.nowPage_t < this.nowPage * 10) {
            this.moreShowBoolen = false;
          }
          this.nowPage++;
        });
    },
    editshow() {
      this.showji = false;
      // this.$router.push('/home_users')
    },
    pass_db(id, db) {
      // const info = user_model.getUserinfo()
      let data = new FormData();
      data.append("support_community_pass", db);
      data.append("support_community_userid", this.$api.getUserInfo().openid);
      data.append("support_supplement_text", "暂无！");
      this.$api
        .postAPI(
          `mutual/assistance/` + id + `?appid=202108&type_id=3001&state=1`,
          data
        )
        .then((res) => {
          this.$Message.success("操作成功！");
          //this.showji = true
        });
      // this.$axios.post("app/mutual/assistance/" + id + "?appid=202108&type_id=3001", {
      //   params: {
      //     support_community_pass: db,
      //     support_community_userid: info.openid,
      //     support_supplement_text: "暂无！"
      //   }
      // }).then(res => {
      //   //this.list = res.data.data.data[0].models
      //   console.log(res.data);
      //   this.showji = true
      // })
    },
    route(id) {
      // console.log(id);
      this.$router.push({
        name: "user_help_save",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style>
.btn-primary {
  color: #fff;
  background-color: #01b2c2;
  border-color: #01b2c2;
}
.btn1 {
  border: none;
  outline: 0;
  background: none;
}
.cent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #777;
  font-size: 20px;
}

.jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}

.label_50 {
  border-radius: 50px/50px;
}

.page-header {
  margin: 25px 0 0px;
}

.h5_t_5 {
  margin-top: 15px;
}

.b_t_5 {
  padding-top: 6px;
}

.border_ {
  background: #002752;
}

.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -40px;
}

.carousel-indicators li {
  background-color: #000000;
}

.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}

.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}

.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}

.jumbotron_b {
  color: #fff;
  background: #3480fa;
}

.jumbotron_c {
  background: #f3f4f8;
}

.carousel-indicators li {
  width: 8px;
  height: 8px;
  background-color: #00cdc6;
}

.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 8px;
}

.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}

.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/user_examine_list.vue